<template lang="pug">
GenericCard(size='40')
  FancyHeader.sticky-top(
    title='ลำดับการแข่งขัน'
    :backgroundSrc='require(`@/assets/profile-performance/header-background-leader-board.png`)'
  )

  .leader-board-panel.scrollable.py-2.px-2
    template(v-for='(user, i) in listData')
      GenericCard.px-2.py-2(:key='i' size='36')
        .px-3.py-3
          .d-flex
            div(style='width: 48px;')
              template(v-if='i === 0')
                img(src='@/assets/icons/medal-gold.svg')
              template(v-else-if='i === 1')
                img(src='@/assets/icons/medal-silver.svg')
              template(v-else-if='i === 2')
                img(src='@/assets/icons/medal-bronze.svg')
              template(v-else)
                div(style='color: #134D8B; font-size: 40px;')
                  | {{ i+1 }}

            img.rounded-circle(
              :src='user.user_avatar' width='56' height='56'
            )
            .d-flex.flex-column.ml-3
              .text-large {{ user.name }}
              .text-medium เขต {{ user.area_id }}

          .text-small.mt-3 ยอดขายที่ทำได้
          .progress.small.mt-2
            .progress-bar(
              :style='`width: ${calcPercentage(user.total, user.goal)}%`'
            )
          .d-flex.justify-content-between.mt-1
            .text-turquoise.font-weight-500 {{ parseFloat(user.total) | currency }}
            .text-blue.font-weight-500 {{ parseFloat(user.goal) | currency }}
</template>

<script>
import FancyHeader from '@/components/profile-performance/FancyHeader.vue';

export default {
  components: {
    FancyHeader,
  },
  data: () => ({
    listData: [
    ],
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      const res = await this.$api.user.saleGoalLeaderboard();
      if (res.status === 200) {
        this.listData = res.data;
        console.log(res.data);
      }

      this.isLoading = false;
    },
    formatDate(dateString) {
      return this.$moment(dateString).format('DD/MM/YYYY');
    },

    calcPercentage(value, total) {
      if (total === 0) { return 100; }
      const percentage = value / total * 100;
      return percentage < 100 ? percentage : 100;
    },
  },
};
</script>

<style lang="scss">
.leader-board-panel {
  background-color: #EDF1F6;
}
</style>
